import { z } from 'zod';
import { CrmBoardQuery } from './crm';

export const CrmHintKind = z.enum(['onboard', 'event']);
export type CrmHintKind = z.infer<typeof CrmHintKind>;

export const CrmManagerHintStatus = z.enum(['active', 'completed', 'dismissed']);
export type CrmManagerHintStatus = z.infer<typeof CrmManagerHintStatus>;

export const CrmManagerHintDto = z.object({
  id: z.uuid(),
  hintId: z.string().min(1),
  kind: CrmHintKind,
  dealId: z.uuid(),
  contactUserId: z.uuid(),
  contactLabel: z.string(),
  whyNow: z.string().max(500),
  howToStart: z.string().max(800),
  offerLabel: z.string().max(200),
  /** Для менеджера: почему ивент подходит; для onboard — null. */
  matchReason: z.string().max(500).nullable(),
  event: z
    .object({
      id: z.uuid(),
      title: z.string(),
      startsAt: z.iso.datetime(),
      timeZone: z.string(),
      priceMinor: z.number().int().nonnegative().nullable(),
      currency: z.string().length(3).nullable(),
    })
    .nullable(),
  reward: z
    .object({
      potentialEnergy: z.number().int().nonnegative(),
      label: z.string(),
      condition: z.string(),
    })
    .nullable(),
});
export type CrmManagerHintDto = z.infer<typeof CrmManagerHintDto>;

export const CrmSuggestionsDto = z.object({
  items: z.array(CrmManagerHintDto).max(3),
  error: z.enum(['llm_failed', 'none']).default('none'),
});
export type CrmSuggestionsDto = z.infer<typeof CrmSuggestionsDto>;

export const CrmSuggestionsQuery = CrmBoardQuery;
export type CrmSuggestionsQuery = z.infer<typeof CrmSuggestionsQuery>;

export const CrmManagerHintStatusBody = z.object({
  status: z.enum(['completed', 'dismissed']),
});
export type CrmManagerHintStatusBody = z.infer<typeof CrmManagerHintStatusBody>;

export const CrmComposeMessageBody = z.object({
  hintId: z.string().min(1),
  kind: CrmHintKind,
  contactUserId: z.uuid(),
  eventId: z.uuid().optional(),
  contextText: z.string().max(500).optional(),
  useAi: z.boolean().optional(),
});
export type CrmComposeMessageBody = z.infer<typeof CrmComposeMessageBody>;

export const CrmComposeMessageDto = z.object({
  draft: z.string().max(4000),
  usedAi: z.boolean(),
});
export type CrmComposeMessageDto = z.infer<typeof CrmComposeMessageDto>;
